import React from 'react';
import { Label } from '../Label';
export const ActiveLabel = ({ withIcon }) => (React.createElement(Label, Object.assign({ padding: "medium", backgroundColor: "green100", textColor: "green700", fontSize: "10px", letterSpacing: "normal" }, (withIcon ? { icon: 'Check' } : {})), "activ\u00E9"));
